<template>
  <div class="supply-dashboard">
    <span style="font-size: 10px; color: red" v-if="errorMessage">
      {{ errorMessage }}</span
    >
    <div class="top-menu">
      <BaseInputLogic
        ref="menuLogic"
        class="ml-0"
        style="margin-bottom: 13px"
        :options="menu.options"
        :value.sync="menu.value"
        @onDataChange="handleInputChange(menu.value)"
      ></BaseInputLogic>

      <success-fade-alert
        ref="successFadeAlert"
        :msg="alert.success"
        class="success-alert-fixed"
      />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

      <!-- Checkbox de refresh a cada 5 min -->
      <b-form-checkbox
        v-model="isAutoRefreshEnabled"
        class="auto-refresh"
        switch
      >
        Atualização Automática
      </b-form-checkbox>
    </div>
    <!-- Primeira aba -->
    <div v-if="menu.value == '1'">
      <div class="filters">
        <SuspenseListFilter
          :title="filterTitles.plate"
          :options="supplyDashboardData.filterOptions.plate"
          :value.sync="filterValues.plate"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.fuelType"
          :options="supplyDashboardData.filterOptions.fuelType"
          :value.sync="filterValues.fuelType"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.vehicleModel"
          :options="supplyDashboardData.filterOptions.vehicleModel"
          :value.sync="filterValues.vehicleModel"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.costCenter"
          :options="supplyDashboardData.filterOptions.costCenter"
          :value.sync="filterValues.costCenter"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.fuelStation"
          :options="supplyDashboardData.filterOptions.fuelStation"
          :value.sync="filterValues.fuelStation"
          @filter-changed="filterEmit"
        />
        <DataRangeFilter
          :title="filterTitles.dataRange"
          :startDate.sync="filterValues.startDate"
          :endDate.sync="filterValues.endDate"
          @filter-changed="filterEmit"
        />
        <b-form-checkbox
          v-model="filterValues.dashboardNullifyFirstSupply"
          switch
          class="mt-3"
          @change="filterEmit"
        >
          Zerar primeiro abastecimento listado
        </b-form-checkbox>
        <b-button
          @click="clearFilters"
          style="height: 40px; margin-top: 27px"
          class="btn btn-secondary"
          size="sm"
          >Limpar Filtros</b-button
        >
      </div>
      <div class="cards">
        <div class="gauge">
          <GaugeEChart
            :title="chartTitles.averageGeneralConsum"
            :model="supplyDashboardData.charts.averageGeneralConsum.model"
            :isHorimeter="true"
          />
        </div>
        <CardEChart
          :title="cardTitles.totalKm"
          :value="supplyDashboardData.cards.totalKm.value"
          :icon="cardIcons.truckIcon"
        />
        <CardEChart
          :title="cardTitles.dieselFueledValue"
          :value="supplyDashboardData.cards.dieselFueledValue.value"
          :icon="cardIcons.moneyIcon"
        />
        <CardEChart
          :title="cardTitles.totalLitersSupplied"
          :value="supplyDashboardData.cards.totalLitersSupplied.value"
          :icon="cardIcons.fuelIcon"
        />
        <LogicCardEChart
          :title="cardTitles.economy"
          :value="supplyDashboardData.cards.economy.value"
          :icon="cardIcons.goalIcon"
          :type="'result'"
        />
      </div>
      <div class="charts">
        <BarEChart
          key="averagePerVehiclePage1"
          :title="chartTitles.averagePerVehicle"
          :model="supplyDashboardData.charts.averagePerVehicle.model"
        />
        <BarEChartHorizontal
          key="economyPerDriverPage1"
          :title="chartTitles.kilometerPerVehicle"
          :model="supplyDashboardData.charts.kilometerPerVehicle.model"
          barType="hoursWorked"
        />
      </div>
    </div>

    <!-- Segunda aba -->
    <div v-if="menu.value == '2'">
      <div class="filters">
        <SuspenseListFilter
          :title="filterTitles.plate"
          :options="supplyDashboardData.filterOptions.plate"
          :value.sync="filterValues.plate"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.driver"
          :options="supplyDashboardData.filterOptions.driver"
          :value.sync="filterValues.driver"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.costCenter"
          :options="supplyDashboardData.filterOptions.costCenter"
          :value.sync="filterValues.costCenter"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.fuelStation"
          :options="supplyDashboardData.filterOptions.fuelStation"
          :value.sync="filterValues.fuelStation"
          @filter-changed="filterEmit"
        />
        <DataRangeFilter
          :title="filterTitles.dataRange"
          :startDate.sync="filterValues.startDate"
          :endDate.sync="filterValues.endDate"
          @filter-changed="filterEmit"
        />
        <b-form-checkbox
          v-model="filterValues.dashboardNullifyFirstSupply"
          switch
          class="mt-3"
          @change="filterEmit"
        >
          Zerar primeiro abastecimento listado
        </b-form-checkbox>
        <b-button
          size="sm"
          style="height: 40px; margin-top: 27px"
          @click="clearFilters"
          class="btn btn-secondary mb-3"
          >Limpar Filtros</b-button
        >
      </div>
      <LogicCardEChart
        :title="cardTitles.economy"
        :value="supplyDashboardData.cards.economy.value"
        :icon="cardIcons.moneyIcon"
        :type="'result'"
      />
      <div class="charts2">
        <BarEChartHorizontal
          key="economyPerDriverPage2"
          :title="chartTitles.economyPerDriver"
          :model="supplyDashboardData.charts.economyPerDriver.model"
          barType="economy"
        />
        <BarEChartHorizontal
          key="economyPerVehiclePage2"
          :title="chartTitles.economyPerVehicle"
          :model="supplyDashboardData.charts.economyPerVehicle.model"
          barType="economy"
        />
        <BarEChartHorizontal
          key="averagePerPlatePage2"
          :title="chartTitles.averagePerPlate"
          :model="supplyDashboardData.charts.averagePerVehicle.model"
        />
      </div>
    </div>

    <!-- Terceira aba -->
    <div v-show="menu.value == '3'">
      <div class="filters">
        <!-- 3 filters -->
        <SuspenseListFilter
          :title="filterTitles.checklist"
          :options="supplyDashboardData.filterOptions.checklist"
          :value.sync="filterValues.originChecklistId"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.driver"
          :options="supplyDashboardData.filterOptions.driver"
          :value.sync="filterValues.driver"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.plate"
          :options="supplyDashboardData.filterOptions.plate"
          :value.sync="filterValues.plate"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.costCenter"
          :options="supplyDashboardData.filterOptions.costCenter"
          :value.sync="filterValues.costCenter"
          @filter-changed="filterEmit"
        />
        <SuspenseListFilter
          :title="filterTitles.fuelStation"
          :options="supplyDashboardData.filterOptions.fuelStation"
          :value.sync="filterValues.fuelStation"
          @filter-changed="filterEmit"
        />
        <DataRangeFilter
          :title="filterTitles.dataRange"
          :startDate.sync="filterValues.startDate"
          :endDate.sync="filterValues.endDate"
          @filter-changed="filterEmit"
        />
        <b-form-checkbox
          v-model="filterValues.dashboardNullifyFirstSupply"
          switch
          class="mt-3"
          @change="filterEmit"
        >
          Zerar primeiro abastecimento listado
        </b-form-checkbox>
        <b-button
          size="sm"
          style="height: 40px; margin-top: 27px"
          @click="clearFilters"
          class="btn btn-secondary mb-3"
          >Limpar Filtros</b-button
        >
        <b-button
          @click="fetchData()"
          style="height: 40px; margin-top: 27px; display: flex; align-items: center; justify-content: center"
          class="btn btn-secondary"
          size="sm"
          ><i class="material-icons"> refresh </i
          >{{ $t("geral.refresh") }}</b-button
        >
        <b-button
          class="btn btn-secondary ml-2"
          style="height: 40px; margin-top: 27px"
          size="sm"
          @click="goToExportLayout"
        >
          Exportar PDF
        </b-button>
        <b-button
          class="btn btn-secondary ml-2"
          style="height: 40px; margin-top: 27px"
          size="sm"
          :disabled="exportCsvLoading"
          @click="exportCsv"
        >
          Exportar CSV
        </b-button>
      </div>
      <div class="cards">
        <CardEChart
          :title="cardTitles.totalLitersSupplied"
          :value="supplyDashboardData.cards.totalLitersSupplied.value"
          :icon="cardIcons.fuelIcon"
        ></CardEChart>
        <CardEChart
          :title="cardTitles.totalKm"
          :value="supplyDashboardData.cards.totalKm.value"
          :icon="cardIcons.routeIcon"
        ></CardEChart>
        <CardEChart
          :title="cardTitles.average"
          :value="supplyDashboardData.cards.average.value"
          :icon="cardIcons.feetIcon"
        ></CardEChart>
        <CardEChart
          :title="cardTitles.dieselFueledValue"
          :value="supplyDashboardData.cards.dieselFueledValue.value"
          :icon="cardIcons.moneyIcon"
        ></CardEChart>
        <LogicCardEChart
          :title="cardTitles.positiveEconomy"
          :value="supplyDashboardData.cards.positiveEconomy.value"
          :icon="cardIcons.positiveResultIcon"
          :type="'gain'"
        />
        <LogicCardEChart
          :title="cardTitles.negativeEconomy"
          :value="supplyDashboardData.cards.negativeEconomy.value"
          :icon="cardIcons.negativeResultIcon"
          :type="'loss'"
        />
        <LogicCardEChart
          :title="cardTitles.economy"
          :value="supplyDashboardData.cards.economy.value"
          :icon="cardIcons.goalIcon"
          :type="'result'"
          class="full-width-card"
        />
      </div>
        <div style="margin-top: 15px;">
          <div style="text-align: end;">
            <b-button
              class="btn btn-secondary mr-2"
              style="height: 40px; border-radius: 0.4285rem;"
              size="sm"
              :disabled="saveTablePrefsLoading"
              @click="savePreferences('tablePrefs', tableColumnPrefs)"
            >
              Salvar preferências
            </b-button>
            <b-dropdown
              :variant="$store.state.darkmode ? 'dark' : 'secondary'"
              text="Colunas"
              right
              class="m-2"
              :toggle-class="$store.state.darkmode ? 'btn-dark text-white' : ''"
              :menu-class="$store.state.darkmode ? 'bg-dark text-white' : ''"
            >
              <div class="p-2 border-bottom">
                <b-form-checkbox
                  switch
                  size="sm"
                  :checked="allColumnsVisible"
                  @change="toggleAllColumns"
                >
                  Selecionar todos
                </b-form-checkbox>
              </div>
              <div
                v-for="(pref, index) in tableColumnPrefs"
                :key="pref.colId"
                class="p-2"
              >
                <b-form-checkbox
                  :checked="!tableColumnPrefs[index].hide"
                  @change="toggleColumnVisibility(index, $event)"
                  switch
                  size="sm"
                  style="cursor: pointer;"
                >
                  {{ getHeaderName(pref.colId) }}
                </b-form-checkbox>
              </div>
            </b-dropdown>
          </div>
          <TableAgGrid
            ref="mainTable"
            :columnDefs="tableColumnDefs"
            :rowData="supplyDashboardData.tableData"
            :defaultColumnPrefs="tableColumnPrefs"
            @column-state-changed="onMainTableStateChanged"
            @sort-changed="handleSortedColumnChanged"
          />
        </div>
    </div>

    <div v-show="menu.value == '4'">
      <b-row class="mt-3" style="margin: 0;">
        <b-card
          class="mb-2"
          :class="$store.state.darkmode ? 'dark-collapse' : ''"
        >
          <b-card-header
            v-b-toggle="'collapse-campos-visualizados'"
            style="padding: 5px;"
          >
            <h5 class="mb-0 d-flex justify-content-between align-items-center">
              <span>
                Campos visualizados
              </span>
              <i
                :class="
                  collapseOpen
                    ? 'tim-icons icon-minimal-up'
                    : 'tim-icons icon-minimal-down'
                "
              ></i>
            </h5>
          </b-card-header>
          <b-collapse
            id="collapse-campos-visualizados"
            @show="collapseOpen = true"
            @hide="collapseOpen = false"
          >
            <b-card-body>
              <b-row class="mt-3">
                <b-col md="4">
                  <b-form-group label="Cards" label-for="cards">
                    <b-form-checkbox-group
                      v-model="selected"
                      :options="LayoutOptionsCards"
                      switches
                      stacked
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Tabelas" label-for="tables">
                    <b-form-checkbox-group
                      v-model="selected"
                      :options="LayoutOptionsTables"
                      switches
                      stacked
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6">
          <b-card
            class="mb-2"
            :class="$store.state.darkmode ? 'dark-collapse' : ''"
          >
            <b-card-header
              v-b-toggle="'collapse-cabecalho'"
              style="cursor: pointer; padding: 5px;"
            >
              <h5
                class="mb-0 d-flex justify-content-between align-items-center"
              >
                <span>
                  <i class="tim-icons icon-fuel-pump"></i> Cabeçalho
                </span>
                <i
                  :class="
                    collapseHeader
                      ? 'tim-icons icon-minimal-up'
                      : 'tim-icons icon-minimal-down'
                  "
                ></i>
              </h5>
            </b-card-header>
            <b-collapse
              id="collapse-cabecalho"
              @show="collapseHeader = true"
              @hide="collapseHeader = false"
            >
              <b-card-body>
                <b-row class="mt-3">
                  <b-col md="12">
                    <b-form-checkbox
                      v-model="pdfExportPrefs.header.viewHeaderInAllPages"
                      name="view-header-in-all-pages"
                      switch
                      stacked
                    >
                      Cabeçalho em todas as páginas
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="pdfExportPrefs.header.includeFilters"
                      name="include-filters"
                      switch
                      stacked
                    >
                      Incluir filtros aplicados
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>

        <b-col md="6">
          <b-card
            class="mb-2"
            :class="$store.state.darkmode ? 'dark-collapse' : ''"
          >
            <b-card-header
              v-b-toggle="'collapse-config-pdf'"
              style="cursor: pointer; padding: 5px;"
            >
              <h5
                class="mb-0 d-flex justify-content-between align-items-center"
              >
                <span>
                  <i class="tim-icons icon-fuel-pump"></i> Configurações PDF
                </span>
                <i
                  :class="
                    collapseConfigPdf
                      ? 'tim-icons icon-minimal-up'
                      : 'tim-icons icon-minimal-down'
                  "
                ></i>
              </h5>
            </b-card-header>
            <b-collapse
              id="collapse-config-pdf"
              @show="collapseConfigPdf = true"
              @hide="collapseConfigPdf = false"
            >
              <b-card-body>
                <b-row class="mt-3">
                  <b-col md="12">
                    <b-form-group
                      label="Orientação das páginas"
                      label-for="pagesOrientation"
                    >
                      <b-form-checkbox
                        id="pageOrientation"
                        v-model="pdfExportPrefs.pdfConfig.pagesOrientation"
                        :value="0"
                        :unchecked-value="1"
                      >
                        Vertical
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mt-3"
                        id="pageOrientation"
                        v-model="pdfExportPrefs.pdfConfig.pagesOrientation"
                        :value="1"
                        :unchecked-value="0"
                      >
                        Horizontal
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      label="Apelido do relatório"
                      label-for="pagesOrientation"
                    >
                      <b-form-input
                        type="text"
                        id="input-reportNickname"
                        placeholder="Apelido do relatório"
                        v-model="pdfExportPrefs.pdfConfig.reportNickname"
                      />
                    </b-form-group>
                    <b-form-group
                      label="Largura das colunas"
                      label-for="columnWidthPref"
                    >
                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          id="columnWidthPref"
                          v-model="pdfExportPrefs.pdfConfig.columnsWidth"
                          :value="0"
                          :unchecked-value="1"
                        >
                          Respeitar preferências
                        </b-form-checkbox>
                        <i
                          id="tooltip-columnWidthPref"
                          class="tim-icons icon-alert-circle-exc ml-1"
                          style="font-size:16px; cursor:help"
                        ></i>
                        <b-tooltip
                          target="tooltip-columnWidthPref"
                          title="A largura das colunas do PDF respeitarão o tamanho das colunas que você definiu na visualização da tabela de abastecimentos de acordo com as suas preferências."
                          placement="right"
                        />
                      </div>
                      <div class="d-flex align-items-center mt-3">
                        <b-form-checkbox
                          id="columnWidthMin"
                          v-model="pdfExportPrefs.pdfConfig.columnsWidth"
                          :value="1"
                          :unchecked-value="0"
                        >
                          Respeitar largura mínima
                        </b-form-checkbox>
                        <i
                          id="tooltip-columnWidthMin"
                          class="tim-icons icon-alert-circle-exc ml-1"
                          style="font-size:16px; cursor:help"
                        ></i>
                        <b-tooltip
                          target="tooltip-columnWidthMin"
                          title="A largura das colunas do PDF respeitarão a menor largura possível de acordo com o tamanho do conteúdo impresso nas mesmas."
                          placement="right"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-3" style="margin: 0; justify-content: end;">
        <b-button
          class="btn btn-secondary mr-2"
          style="height: 40px; margin-top: 27px; "
          size="sm"
          :disabled="savePdfExportPrefsLoading"
          @click="savePreferences('pdfExportPrefs', pdfExportPrefs)"
        >
          Salvar preferências
        </b-button>
        <b-button
          class="btn btn-secondary"
          style="height: 40px; margin-top: 27px; "
          size="sm"
          :disabled="exportPdfLoading"
          @click="exportPdfCustom"
        >
          Exportar PDF
        </b-button>
      </b-row>

      <div class="paper" :style="{ width: paperWidth, height: '100%' }">
        <grid-layout
          :layout="visibleLayout"
          :col-num="12"
          :row-height="30"
          :is-draggable="true"
          :is-resizable="true"
          :auto-size="true"
        >
          <grid-item
            v-for="item in visibleLayout"
            :key="item.i"
            :is-resizable="!item.noResize"
            :i="item.i"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :static="item.static"
          >
            <component
              :is="item.component"
              v-bind="resolveProps(item)"
              v-on="resolveListeners(item)"
            >
            </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>

<script>
import BarEChart from "../Charts/BarEChart.vue";
import BarEChartHorizontal from "../Charts/BarEChartHorizontal.vue";
import GaugeEChart from "../Charts/GaugeEChart.vue";
import CardEChart from "../Charts/CardEChart.vue";
import SuspenseListFilter from "../Charts/SuspenseListFilter.vue";
import DataRangeFilter from "../Charts/DataRangeFilter.vue";
import TableChartComponent from "@/pagesRms/checklist/Dashboard/Horimetro/Components/TableChartComponentHorimetro.vue";
import BaseInputLogic from "@/components_rms/base/BaseImputLogic.vue";
import LogicCardEChart from "../Charts/LogicCardEChart.vue";
import { debounce } from "throttle-debounce";
import { formatToBrazilianCurrency } from "@/mixins/formatToBrazilianCurrency.js";
import VueGridLayout from "vue-grid-layout";
import { jsPDF } from "jspdf";
import JsPDFAutotable from "jspdf-autotable";
import TableAgGrid from "src/components_rms/agGrid/TableAgGrid.vue";
import PdfHeader from "src/components_rms/PdfExport/PdfHeader.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "SupplyDashboard",
  components: {
    BarEChart,
    BarEChartHorizontal,
    GaugeEChart,
    CardEChart,
    SuspenseListFilter,
    DataRangeFilter,
    TableChartComponent,
    BaseInputLogic,
    LogicCardEChart,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    JsPDFAutotable,
    PdfHeader,
    "success-fade-alert": SuccessFadeAlert,
    "fade-alert-danger": FadeAlertDanger,
    TableAgGrid,
  },
  computed: {
    cardIcons() {
      let yellowTruckSrc = "/img/yellow-truck-icon.png";
      let yellowMoneySrc = "/img/yellow-economy-icon.png";
      let yellowFuelSrc = "/img/yellow-fuel-icon.png";
      let yellowRouteSrc = "/img/yellow-route-icon.png";
      let yellowFeetSrc = "/img/yellow-feet-icon.png";
      let yellowGoalSrc = "/img/yellow-goal-icon.png";
      let yellowClockSrc = "/img/yellow-clock-icon.png";

      let blueTruckSrc = "/img/blue-truck-icon.png";
      let blueMoneySrc = "/img/blue-economy-icon.png";
      let blueFuelSrc = "/img/blue-fuel-icon.png";
      let blueRouteSrc = "/img/blue-route-icon.png";
      let blueFeetSrc = "/img/blue-feet-icon.png";
      let blueGoalSrc = "/img/blue-goal-icon.png";
      let blueClockSrc = "/img/blue-clock-icon.png";

      let negativeResultIcon = "/img/negative-result-icon.png";
      let positiveResultIcon = "/img/positive-result-icon.png";

      let truckIcon, moneyIcon, fuelIcon, routeIcon, feetIcon, goalIcon;

      if (!this.$store.state.darkmode) {
        truckIcon = blueClockSrc;
        moneyIcon = blueMoneySrc;
        fuelIcon = blueFuelSrc;
        routeIcon = blueClockSrc;
        feetIcon = blueFeetSrc;
        goalIcon = blueGoalSrc;
      } else {
        truckIcon = yellowClockSrc;
        moneyIcon = yellowMoneySrc;
        fuelIcon = yellowFuelSrc;
        routeIcon = yellowClockSrc;
        feetIcon = yellowFeetSrc;
        goalIcon = yellowGoalSrc;
      }

      return {
        truckIcon,
        moneyIcon,
        fuelIcon,
        routeIcon,
        feetIcon,
        goalIcon,
        negativeResultIcon,
        positiveResultIcon,
      };
    },
    getCompanyFantasyName() {
      return this.$store.getters.companyFantasyName;
    },
    getUserDisplayName() {
      return this.$store.getters.userDisplayname;
    },
    LayoutOptionsCards() {
      return this.pdfExportPrefs.layout
        .filter(item => item.type === "card")
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(item => ({ text: item.name, value: item.i }));
    },
    LayoutOptionsCharts() {
      return this.pdfExportPrefs.layout
        .filter(item => item.type === "chart")
        .map(item => ({ text: item.name, value: item.i }));
    },
    LayoutOptionsTables() {
      return this.pdfExportPrefs.layout
        .filter(item => item.type === "table")
        .map(item => ({ text: item.name, value: item.i }));
    },
    visibleLayout() {
      return this.pdfExportPrefs.layout.filter(item => item.visible);
    },
    allColumnsVisible() {
      return this.tableColumnPrefs.every(pref => !pref.hide);
    },
    isLandscape() {
      return this.pdfExportPrefs.pdfConfig.pagesOrientation === 1;
    },
    paperWidth() {
      return this.isLandscape ? "297mm" : "210mm";
    }
  },
  mounted() {
    this.getAllVehiclePlate();
    this.getAllDrivers();
    this.getAllVehicleModels();
    this.getAllCostCenter();
    this.getAllFuelStation();
    this.getDashboardConfiguration();
    this.getCompanyLogo();
    this.selected = this.pdfExportPrefs.layout
      .filter(item => item.visible)
      .map(item => item.i);
  },
  data() {
    return {
      isAutoRefreshEnabled: false,
      refreshInterval: null,
      errorMessage: null,
      supplyDashboardData: {
        cards: {
          totalKm: {
            value: 0,
          },
          totalConsumedDiesel: {
            value: 0,
          },
          dieselFueledValue: {
            value: "",
          },
          economy: {
            value: "",
          },
          totalLitersSupplied: {
            value: 0,
          },
          negativeEconomy: {
            value: "",
          },
          positiveEconomy: {
            value: "",
          },
          realEconomy: {
            value: "",
          },
          average: {
            value: 0,
          },
          fueledValue: {
            value: "",
          },
        },
        charts: {
          averagePerVehicle: {
            model: {
              xAxis: ["AAA0B01"],
              data: [10],
            },
          },
          kilometerPerVehicle: {
            model: {
              yAxis: ["AAA0B01"],
              data: [10],
            },
          },
          economyPerDriver: {
            model: {
              yAxis: ["João"],
              data: [10],
            },
          },
          averagePerPlate: {
            model: {
              yAxis: ["AAA0B01"],
              data: [10],
            },
          },
          economyPerVehicle: {
            model: {
              yAxis: ["AAA0B01"],
              data: [10],
            },
          },
          averageGeneralConsum: {
            model: {
              min: 0,
              max: 4.66,
              value: 1,
              goal: 2,
            },
          },
        },
        tableData: [
        ],
        filterOptions: {
          plate: [{ value: "1", text: "AAA0B01" }],
          fuelType: [
            { value: "Diesel Comum", text: "Diesel Comum" },
            { value: "Diesel S10", text: "Diesel S10" },
            { value: "Gasolina", text: "Gasolina" },
            { value: "Álcool", text: "Álcool" },
            { value: "AVGAS", text: "AVGAS" },
          ],
          vehicleModel: [{ value: "Caminhão", text: "Caminhão" }],
          day: [
            { value: "01", text: "01" },
            { value: "02", text: "02" },
            { value: "03", text: "03" },
            { value: "04", text: "04" },
            { value: "05", text: "05" },
            { value: "06", text: "06" },
            { value: "07", text: "07" },
            { value: "08", text: "08" },
            { value: "09", text: "09" },
            { value: "10", text: "10" },
            { value: "11", text: "11" },
            { value: "12", text: "12" },
            { value: "13", text: "13" },
            { value: "14", text: "14" },
            { value: "15", text: "15" },
            { value: "16", text: "16" },
            { value: "17", text: "17" },
            { value: "18", text: "18" },
            { value: "19", text: "19" },
            { value: "20", text: "20" },
            { value: "21", text: "21" },
            { value: "22", text: "22" },
            { value: "23", text: "23" },
            { value: "24", text: "24" },
            { value: "25", text: "25" },
            { value: "26", text: "26" },
            { value: "27", text: "27" },
            { value: "28", text: "28" },
            { value: "29", text: "29" },
            { value: "30", text: "30" },
            { value: "31", text: "31" },
          ],
          month: [
            { value: "01", text: "Janeiro" },
            { value: "02", text: "Fevereiro" },
            { value: "03", text: "Março" },
            { value: "04", text: "Abril" },
            { value: "05", text: "Maio" },
            { value: "06", text: "Junho" },
            { value: "07", text: "Julho" },
            { value: "08", text: "Agosto" },
            { value: "09", text: "Setembro" },
            { value: "10", text: "Outubro" },
            { value: "11", text: "Novembro" },
            { value: "12", text: "Dezembro" },
          ],
          year: [
            { value: "2020", text: "2020" },
            { value: "2021", text: "2021" },
            { value: "2022", text: "2022" },
            { value: "2023", text: "2023" },
            { value: "2024", text: "2024" },
            { value: "2022", text: "2022" },
            { value: "2023", text: "2023" },
            { value: "2024", text: "2024" },
          ],
          driver: [{ value: "João", text: "João" }],
          checklist: [{ value: "1", text: "Checklist" }],
          costCenter: [{ value: "1", text: "Centro 1" }],
          fuelStation: [{ value: "1", text: "Posto 1" }],
        },
      },
      cardTitles: {
        totalKm: "Total Horas trabalhadas",
        totalConsumedDiesel: "Litros Consum. Diesel",
        dieselFueledValue: "Valor Abastec.",
        economy: "Resultado",
        totalLitersSupplied: "Total Litros Abastecidos",
        totalKm: "Horas trabalhadas",
        average: "Média",
        fueledValue: "Valor Abastecido",
        positiveEconomy: "Economia",
        negativeEconomy: "Prejuízo",
        realEconomy: "Resultado",
      },
      chartTitles: {
        averagePerVehicle: "Média por Equipamento",
        kilometerPerVehicle: "Horas Trabalhadas por Equipamento",
        averageGeneralConsum: "Média Consumo Geral",
        economyPerDriver: "Economia por Motorista",
        economyPerVehicle: "Economia por Equipamento",
        averagePerPlate: "Média por Equipamento",
      },
      filterTitles: {
        plate: "Equipamento",
        fuelType: "Tipo de Combustível",
        vehicleModel: "Modelo de Equipamento",
        day: "Dia",
        month: "Mês",
        year: "Ano",
        driver: "Motorista",
        dataRange: "Periodo",
        checklist: "Checklist",
        costCenter: "Centro de Custo",
        startDate: "Data Inicial",
        endDate: "Data Final",
        fuelStation: "Posto de Combustível",
        originChecklistId: "Checklist de Origem",
        dashboardNullifyFirstSupply: "Zerar primeiro abastecimento listado"
      },
      filterValues: {
        plate: "",
        fuelType: "",
        vehicleModel: "",
        day: "",
        month: "",
        year: "",
        driver: "",
        startDate: "",
        endDate: "",
        originChecklistId: "",
        costCenter: "",
        fuelStation: "",
        dashboardNullifyFirstSupply: false,
      },
      menu: {
        options: [
        { value: "1", text: "Geral" },
          { value: "2", text: "Economia" },
          { value: "3", text: "Abastecimentos" },
          { value: "4", text: "Layout de exportação" }
        ],
        value: "1",
      },
      previousMenuValue: null,
      selected: [],
      collapseOpen: false,
      collapseHeader: false,
      collapseConfigPdf: false,
      dashboardNullifyFirstSupplyDefault: false,

      pdfExportPrefs: {
        header: {
          viewHeaderInAllPages: false,
          includeFilters: false
        },
        pdfConfig: {
          pagesOrientation: 0,
          reportNickname: "Relatório de Abastecimentos Horímetro",
          columnsWidth: 0
        },
        layout: [
        {
            x: 0,
            y: 0,
            w: 12,
            h: 5,
            i: "PdfHeader",
            name: "Cabeçalho (Preview)",
            type: "header",
            static: true,
            component: "PdfHeader",
            props: {
              reportNickname: "pdfConfig.reportNickname"
            },
            visible: true
          },
          {
            x: 0,
            y: 5,
            w: 4,
            h: 3,
            i: "0",
            name: "Total Litros Abastecidos",
            type: "card",
            noResize: false,
            static: false,
            component: "CardEChart",
            props: {
              title: "totalLitersSupplied",
              value: "totalLitersSupplied",
              icon: "blueTruckSrc"
            },
            visible: true
          },
          {
            x: 4,
            y: 5,
            w: 4,
            h: 3,
            i: "1",
            name: "Horas trabalhadas",
            type: "card",
            noResize: false,
            static: false,
            component: "CardEChart",
            props: {
              title: "totalKm",
              value: "totalKm",
              icon: "blueTruckSrc"
            },
            visible: true
          },
          {
            x: 8,
            y: 5,
            w: 4,
            h: 3,
            i: "2",
            name: "Média",
            type: "card",
            noResize: false,
            static: false,
            component: "CardEChart",
            props: {
              title: "average",
              value: "average",
              icon: "blueArlaSrc"
            },
            visible: true
          },

          {
            x: 4,
            y: 8,
            w: 4,
            h: 3,
            i: "4",
            name: "Valor Abastec.",
            type: "card",
            noResize: false,
            static: false,
            component: "CardEChart",
            props: {
              title: "dieselFueledValue",
              value: "dieselFueledValue",
              icon: "blueTruckSrc"
            },
            visible: true
          },
          {
            x: 8,
            y: 8,
            w: 4,
            h: 3,
            i: "9",
            name: "Economia",
            type: "card",
            noResize: false,
            static: false,
            component: "CardEChart",
            props: {
              title: "positiveEconomy",
              value: "positiveEconomy",
              icon: "blueMoneySrc"
            },
            visible: true
          },
          {
            x: 0,
            y: 11,
            w: 4,
            h: 3,
            i: "5",
            name: "Prejuízo",
            type: "card",
            noResize: false,
            static: false,
            component: "CardEChart",
            props: {
              title: "negativeEconomy",
              value: "negativeEconomy",
              icon: "blueGoalSrc"
            },
            visible: true
          },
          {
            x: 4,
            y: 11,
            w: 4,
            h: 3,
            i: "6",
            name: "Resultado",
            type: "card",
            noResize: false,
            static: false,
            component: "CardEChart",
            props: {
              title: "realEconomy",
              value: "realEconomy",
              icon: "blueGoalSrc"
            },
            visible: true
          },
          {
            x: 0,
            y: 17,
            w: 12,
            h: 13,
            i: "17",
            name: "Lista de Abastecimentos",
            type: "table",
            static: false,
            component: "TableAgGrid",
            props: {
              items: "tableData",
              columns: "tableColumnDefs",
              defaultColumnPrefs: "tableColumnPrefs",
              ref: "gridTable"
            },
            visible: true
          }
          
        ]
      },
      exportPdfLoading: false,
      exportCsvLoading: false,
      saveTablePrefsLoading: false,
      savePdfExportPrefsLoading: false,
      tableColumnDefs: [
        {
          headerName: "Link",
          field: "link",
          cellRenderer: params => {
            return `
              <a href="${params.value}" target="_blank" style="text-decoration: none;">
                <i class="material-icons" style="font-size: 18px; vertical-align: middle;">
                  link
                </i>
              </a>
            `;
          }
        },
        { headerName: "ID", field: "id" },
        { headerName: "Data", field: "date" },
        { headerName: "Horimetro Atual", field: "currentKm" },
        { headerName: "Hora trabalhada", field: "kmDriven" },
        { headerName: "Litros", field: "liters" },
        { headerName: "Preço", field: "price" },
        { headerName: "Valor Total", field: "totalValue" },
        { headerName: "Tipo de Combustível", field: "fuelType" },
        { headerName: "Meta", field: "goal" },
        {
          headerName: "Média",
          field: "average",
          cellStyle: params => {
            let average = parseFloat(
              params.value.replace(/\./g, "").replace(",", ".")
            );
            let goal = parseFloat(
              params.data.goal.replace(/\./g, "").replace(",", ".")
            );
            if (average >= goal) {
              return {
                color: "green",
                "font-weight": "bold"
              };
            } else {
              return {
                color: "red",
                "font-weight": "bold"
              };
            }
          }
        },
        {
          headerName: "Economia",
          field: "economy",
          cellStyle: params => {
            let economy = parseFloat(
              params.value
                .replace(/[^0-9,-]+/g, "")
                .replace(/\./g, "")
                .replace(",", ".")
            );
            if (economy > 0) {
              return {
                color: "green",
                "font-weight": "bold"
              };
            } else if (economy < 0) {
              return {
                color: "red",
                "font-weight": "bold"
              };
            }
          }
        },
        { headerName: "Equipamento", field: "licensePlate", sortable: true },
        { headerName: "Motorista", field: "driver", sortable: true }
      ],
      tableColumnPrefs: [
        { colId: "link", width: 90, hide: false },
        { colId: "id", width: 95, hide: false },
        { colId: "date", width: 125, hide: false },
        { colId: "currentKm", width: 113, hide: false },
        { colId: "kmDriven", width: 144, hide: false },
        { colId: "liters", width: 93, hide: false },
        { colId: "price", width: 101, hide: false },
        { colId: "totalValue", width: 123, hide: false },
        { colId: "fuelType", width: 170, hide: false },
        { colId: "goal", width: 87, hide: false },
        { colId: "average", width: 111, hide: false },
        { colId: "economy", width: 139, hide: false },
        { colId: "licensePlate", width: 112, hide: false },
        { colId: "driver", width: 246, hide: false }
      ],
      sortedColumn: null,
      companyLogoSrc: "/img/logo_tecnologia_azul.png",
      alert: {
        error: "",
        success: ""
      }
    };
  },
  async created() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    this.filterValues.startDate = this.formatDate(firstDay);
    this.filterValues.endDate = this.formatDate(lastDay);
    await Promise.all([
      this.loadPreferences("tablePrefs"),
      this.loadPreferences("pdfExportPrefs")
    ]);

    this.selected = this.pdfExportPrefs.layout
      .filter(item => item.visible)
      .map(item => item.i);
    this.fetchData();
  },
  watch: {
    isAutoRefreshEnabled(newValue) {
      if (newValue) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    },
    selected(newSel) {
      this.pdfExportPrefs.layout.forEach(item => {
        item.visible = newSel.includes(item.i);
      });
    }
  },
  methods: {
    fetchData() {
      return this.$apiVehicle
        .post("/fuelSupply/dashboard/Horimetro", this.filterValues)
        .then((response) => {
          const dashboardData = response.data;

          this.supplyDashboardData.cards.totalKm.value = dashboardData.totalkm;
          this.supplyDashboardData.cards.totalConsumedDiesel.value =
            dashboardData.totalConsumedDiesel;
          this.supplyDashboardData.cards.dieselFueledValue.value =
            dashboardData.dieselFueledValue;
          this.supplyDashboardData.cards.economy.value =
            formatToBrazilianCurrency(dashboardData.economy);
          this.supplyDashboardData.cards.totalLitersSupplied.value =
            dashboardData.totalLitersSupplied;

          this.supplyDashboardData.charts.averagePerVehicle.model =
            dashboardData.averagesPerVehicle;
          this.supplyDashboardData.charts.economyPerDriver.model =
            dashboardData.economyPerDriver;
          this.supplyDashboardData.charts.economyPerVehicle.model =
            dashboardData.economyPerVehicle;
          this.supplyDashboardData.charts.kilometerPerVehicle.model =
            dashboardData.kilometersPerVehicle;
          this.supplyDashboardData.charts.averageGeneralConsum.model.max =
            dashboardData.averageGeneralConsum.maximal;
          this.supplyDashboardData.charts.averageGeneralConsum.model.value =
            dashboardData.averageGeneralConsum.done.toFixed(2);
          this.supplyDashboardData.charts.averageGeneralConsum.model.goal =
            dashboardData.averageGeneralConsum.expected;
          this.supplyDashboardData.tableData =
            dashboardData.vehiclesSupplies.map((item) => {
              return {
                ...item,
                economy: formatToBrazilianCurrency(parseFloat(item.economy)),
              };
            });
          this.supplyDashboardData.cards.negativeEconomy.value =
            formatToBrazilianCurrency(dashboardData.economyNegative);
          this.supplyDashboardData.cards.positiveEconomy.value =
            formatToBrazilianCurrency(dashboardData.economyPositive);
          this.supplyDashboardData.cards.realEconomy.value =
            formatToBrazilianCurrency(dashboardData.economyReal);
          this.supplyDashboardData.cards.average.value = dashboardData.average;
          this.supplyDashboardData.cards.fueledValue.value =
            dashboardData.fueledValue;
          this.supplyDashboardData.cards.average.value = Number(
            dashboardData.averageGeneralConsum.done
          )
            .toFixed(2)
            .replace(".", ",");
          this.supplyDashboardData.filterOptions.checklist =
            dashboardData.checklistsDropDown;
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            console.log(error);
            console.log(error.response.data.errors);
            return [];
          }
        });
    },
    filterEmit: debounce(500, function () {
      this.fetchData();
    }),
    handleInputChange(newValue) {
      this.fetchData();
      this.menu.value = newValue;
      this.previousMenuValue = newValue;
    },
    getAllVehiclePlate() {
      this.$apiVehicle
        .get("/vehicleRegistration/GetAllDropdown/")
        .then((response) => {
          this.supplyDashboardData.filterOptions.plate = response.data;
        })
        .catch((error) => {
          this.verifyExceptionType(error);
        });
    },
    getAllCostCenter() {
      this.$apiScheduler
        .get("/costCenter/dropdown/")
        .then((response) => {
          this.supplyDashboardData.filterOptions.costCenter = response.data;
        })
        .catch((error) => {
          this.verifyExceptionType(error);
        });
    },
    getCompanyLogo() {
      this.$apiScheduler
        .get("/empresa/logo/" + this.$store.getters.companyId, {
          responseType: "blob"
        })
        .then(response => {
          this.companyLogoSrc = URL.createObjectURL(response.data);
          this.errorMessage = null;
        })
        .catch(error => {
          this.verifyExceptionType(error);
          this.errorMessage = null;
        });
    },
    clearFilters() {
      this.filterValues.plate = "";
      this.filterValues.fuelType = "";
      this.filterValues.vehicleModel = "";
      this.filterValues.day = "";
      this.filterValues.month = "";
      this.filterValues.year = "";
      this.filterValues.driver = "";
      this.filterValues.startDate = "";
      this.filterValues.endDate = "";
      this.filterValues.originChecklistId = "";
      this.filterValues.costCenter = "";
      this.filterValues.fuelStation = "";
      this.filterValues.dashboardNullifyFirstSupply =
        this.dashboardNullifyFirstSupplyDefault;
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      this.filterValues.startDate = this.formatDate(firstDay);
      this.filterValues.endDate = this.formatDate(lastDay);

      this.filterEmit();
    },
    getAllDrivers() {
      this.$apiScheduler
        .get("/v1/user/company/dropdownOptions/")
        .then((response) => {
          this.supplyDashboardData.filterOptions.driver = response.data.map(
            (item) => ({
              value: item.id,
              text: item.displayName,
            })
          );
        })
        .catch((error) => {
          this.verifyExceptionType(error);
        });
    },
    getAllVehicleModels() {
      this.$apiScheduler
        .get("/vehicleModel/list")
        .then((response) => {
          this.supplyDashboardData.filterOptions.vehicleModel =
            response.data.map((item) => ({
              value: item.id,
              text: item.name,
            }));
        })
        .catch((error) => {
          this.verifyExceptionType(error);
        });
    },
    getAllFuelStation() {
      this.$apiVehicle
        .get("/gasStation/getAllDropdownString/")
        .then((response) => {
          this.supplyDashboardData.filterOptions.fuelStation = response.data;
        })
        .catch((error) => {
          this.verifyExceptionType(error);
        });
    },
    getDashboardConfiguration() {
      this.$apiChecklist
        .get("fuelSupply/getConfiguration/byCompanyId")
        .then((response) => {
          const value =
            response.data && response.data.dashboardNullifyFirstSupply;
          this.dashboardNullifyFirstSupplyDefault = value;
          this.filterValues.dashboardNullifyFirstSupply = value;
        })
        .catch((error) => {
          this.verifyExceptionType(error);
        });
    },
    verifyExceptionType(error) {
      if (error.response.status == 401) {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/login");
        });
      } else {
        this.errorMessage = error.message;
      }
    },
    startAutoRefresh() {
      this.refreshInterval = setInterval(() => {
        this.fetchData();
      }, 300000);
    },
    stopAutoRefresh() {
      clearInterval(this.refreshInterval);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    async exportPdfCustom() {
      this.exportPdfLoading = true;

      let pageOrientation = this.pdfExportPrefs.pdfConfig.pagesOrientation;
      const headerInAllPages = this.pdfExportPrefs.header.viewHeaderInAllPages;
      const reportNickname = this.pdfExportPrefs.pdfConfig.reportNickname;
      const logoSrc = this.companyLogoSrc;

      const margin = 10;
      let pageWidth = pageOrientation == 1 ? 297 : 210;
      let pageHeight = pageOrientation == 1 ? 210 : 297;
      let contentWidth = pageWidth - margin * 2;
      const contentHeight = pageHeight - margin * 2;
      const colNum = 12;
      let colWidth = contentWidth / colNum;
      const rowHeight = 10;
      const cardsMargin = 5;
      let logoDimensions;

      const visiblePrefs = this.tableColumnPrefs.filter(pref => !pref.hide);
      const conversionPixelsToMilimetersFactor = 25.4 / 96;

      let columnTotalWidth = 0;
      visiblePrefs.forEach((pref, index) => {
        columnTotalWidth += pref.width * conversionPixelsToMilimetersFactor;
      });
      columnTotalWidth += margin * 2;

      if (
        pageOrientation == 0 &&
        columnTotalWidth > 210 &&
        this.supplyDashboardData.tableData.length > 0
      ) {
        pageOrientation = 1;
        pageWidth = 297;
        pageHeight = 210;
        contentWidth = pageWidth - margin * 2;
        colWidth = contentWidth / colNum;
      }

      require("jspdf-autotable");
      const doc = new jsPDF({
        orientation: pageOrientation == 1 ? "landscape" : "portrait",
        unit: "mm",
        format: "a4"
      });

      try {
        logoDimensions = await this.getImageDimensions(logoSrc);
      } catch (error) {
        console.error("Erro ao carregar a imagem:", error);
      }

      let headerHeight = await this.pdfAddHeader(
        doc,
        margin,
        pageWidth,
        logoDimensions,
        logoSrc
      );

      let filterHeight = headerHeight + margin;
      if (this.pdfExportPrefs.header.includeFilters) {
        filterHeight = await this.pdfAddAppliedFilters(
          doc,
          headerHeight,
          margin,
          pageWidth,
          pageOrientation
        );
      }

      let countCards = 0;
      for (const item of this.pdfExportPrefs.layout.filter(
        item => item.visible
      )) {
        const x = margin + colWidth * item.x;
        const y = filterHeight + rowHeight * (item.y - 5);

        const width = item.w * colWidth;
        const height = item.h * rowHeight;

        if (item.type === "card") {
          await this.pdfAddCard(
            doc,
            this.resolveProps(item),
            x,
            y,
            width,
            height,
            cardsMargin
          );

          countCards++;
        } else if (item.type === "table") {
          const exportPrefs = visiblePrefs.filter(
            pref => pref.colId !== "link"
          );

          const headers = exportPrefs.map(pref =>
            this.getHeaderName(pref.colId)
          );

          let columnStyles = {};
          if (this.pdfExportPrefs.pdfConfig.columnsWidth === 0) {
            exportPrefs.forEach((pref, index) => {
              columnStyles = {
                ...columnStyles,
                [index]: {
                  cellWidth: pref.width * conversionPixelsToMilimetersFactor
                }
              };
            });
          } else {
          }

          const sortedData = this.getSortedTableData();
          const data = sortedData.map(row => {
            return exportPrefs.map(pref => row[pref.colId]);
          });

          let tableStartY;
          if (headerInAllPages) {
            tableStartY =
              margin +
              (await this.pdfAddHeader(
                doc,
                margin,
                pageWidth,
                logoDimensions,
                logoSrc
              ));
          } else {
            tableStartY = margin;
          }

          if (countCards > 0) {
            this.pdfAddPage(doc, pageOrientation);
          } else {
            tableStartY = filterHeight;
          }

          doc.autoTable({
            head: [headers],
            body: data,
            columnStyles: columnStyles,
            tableWidth: "wrap",
            didDrawPage: data => {
              if (headerInAllPages) {
                this.pdfAddHeader(
                  doc,
                  margin,
                  pageWidth,
                  logoDimensions,
                  logoSrc
                );
              }
            },
            didParseCell: data => {
              let headerIndex = data.column.dataKey;
              let columnName = headers[headerIndex];

              if (data.section == "body") {
                switch (columnName) {
                  case "Média":
                    let average = parseFloat(
                      data.cell.raw.replace(/\./g, "").replace(",", ".")
                    );

                    let goal = parseFloat(
                      this.supplyDashboardData.tableData[data.row.index].goal
                        .replace(/\./g, "")
                        .replace(",", ".")
                    );

                    data.cell.styles.textColor =
                      average >= goal ? "green" : "red";
                    break;

                  case "Economia":
                    let economy = parseFloat(
                      data.cell.raw
                        .replace(/[^\d.,-]/g, "")
                        .replace(/\./g, "")
                        .replace(",", ".")
                    );

                    data.cell.styles.textColor =
                      economy > 0 ? "green" : economy < 0 ? "red" : 80;

                    data.cell.text[0] = `${economy > 0 ? "+" : ""} ${
                      data.cell.text
                    }`;

                    break;
                }
              }
            },
            startY: tableStartY,
            theme: "striped",
            styles: {
              fontSize: 8,
              halign: "left"
            },
            headStyles: {
              fillColor: [19, 38, 81],
              fontSize: 8
            },
            margin: {
              top: headerInAllPages ? headerHeight + margin : margin,
              left: margin,
              right: margin
            },
            horizontalPageBreak: true,
            horizontalPageBreakBehaviour: "immediately",
            horizontalPageBreakRepeat: 0
          });
        }
      }

      await this.pdfAddFooter(doc, pageWidth, pageHeight, margin);

      doc.save(`${this.generatePdfFilename()}`);
      this.exportPdfLoading = false;
    },
    resolvePdfCardText(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }

      return `${value}`;
    },
    truncatePdfTextLines(doc, lines, maxWidth, maxLines) {
      if (lines.length <= maxLines) {
        return lines;
      }

      const truncatedLines = lines.slice(0, maxLines);
      let lastLine = `${truncatedLines[maxLines - 1]}`;

      while (
        lastLine.length > 0 &&
        doc.getTextWidth(`${lastLine}...`) > maxWidth
      ) {
        lastLine = lastLine.slice(0, -1);
      }

      truncatedLines[maxLines - 1] = `${lastLine.trimEnd()}...`;
      return truncatedLines;
    },
    buildPdfTextLayout(
      doc,
      text,
      maxWidth,
      initialFontSize,
      minFontSize = 8,
      maxLines = 2
    ) {
      let fontSize = initialFontSize;
      let lines = [text];

      while (fontSize >= minFontSize) {
        doc.setFontSize(fontSize);
        lines = doc.splitTextToSize(text, maxWidth);

        if (lines.length <= maxLines) {
          break;
        }

        fontSize--;
      }

      if (lines.length > maxLines) {
        lines = this.truncatePdfTextLines(doc, lines, maxWidth, maxLines);
      }

      return {
        fontSize,
        lines,
      };
    },
    async pdfAddCard(doc, cardProps, x, y, width, height, cardsMargin = 0) {
      const innerX = x + cardsMargin / 2;
      const innerY = y + cardsMargin / 2;
      const innerWidth = width - cardsMargin;
      const innerHeight = height - cardsMargin;
      const padding = 4;

      doc.setFillColor(255, 255, 255);
      doc.setDrawColor(82, 95, 127);
      doc.setLineWidth(0.3);
      doc.roundedRect(innerX, innerY, innerWidth, innerHeight, 3, 3, "FD");

      let textAreaWidth = innerWidth - padding * 2;

      if (cardProps.icon) {
        try {
          const iconSize = Math.min(10, innerHeight - padding * 2);
          doc.addImage(
            cardProps.icon,
            "PNG",
            innerX + padding,
            innerY + padding,
            iconSize,
            iconSize
          );
          textAreaWidth -= iconSize + 2;
        } catch (error) {
          textAreaWidth = innerWidth - padding * 2;
        }
      }

      const titleLayout = this.buildPdfTextLayout(
        doc,
        this.resolvePdfCardText(cardProps.title),
        textAreaWidth,
        9,
        7,
        2
      );
      doc.setFont("helvetica", "normal");
      doc.setFontSize(titleLayout.fontSize);
      doc.setTextColor(120, 120, 120);
      doc.text(
        titleLayout.lines,
        innerX + innerWidth - padding,
        innerY + padding + titleLayout.fontSize / 2.6,
        { align: "right" }
      );

      const valueLayout = this.buildPdfTextLayout(
        doc,
        this.resolvePdfCardText(cardProps.value),
        textAreaWidth,
        16,
        9,
        2
      );
      doc.setFont("helvetica", "bold");
      doc.setFontSize(valueLayout.fontSize);
      doc.setTextColor(30, 30, 47);

      const valueHeight = doc.getTextDimensions(valueLayout.lines).h;
      doc.text(
        valueLayout.lines,
        innerX + innerWidth - padding,
        innerY +
          innerHeight -
          padding -
          valueHeight +
          valueLayout.fontSize / 2.6,
        { align: "right" }
      );

      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);
    },
    async pdfAddHeader(doc, margin, pageWidth, logoDimensions, logoSrc) {
      const startX = margin;
      const startY = margin;
      const headerSpacing = 5;
      const headerLineSpacing = 2;
      const headerFontSize = 11;
      const headerFontDivisionBase = 3;
      const logoHeaderWidth = 45;

      const ratio = logoDimensions.height / logoDimensions.width;
      let logoHeaderHeight = logoHeaderWidth * ratio;

      const headerInfoStartX = startX + logoHeaderWidth;
      const headerInfoStartY = startY;

      const now = new Date();
      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();
      const hour = String(now.getHours()).padStart(2, "0");
      const min = String(now.getMinutes()).padStart(2, "0");
      const formattedExportDate = `${day}/${month}/${year} ${hour}:${min}`;

      // HEADER
      doc.setFontSize(headerFontSize);
      doc.setTextColor(100);
      // LINE 1
      let headerLine = 0;
      doc.text(
        `RELATÓRIO: ${this.pdfExportPrefs.pdfConfig.reportNickname}`,
        headerInfoStartX + headerSpacing,
        headerInfoStartY +
          headerFontSize / headerFontDivisionBase +
          (headerFontSize / headerFontDivisionBase) * 0
      );
      // LINE 2
      headerLine = 1;
      doc.text(
        `EMPRESA: ${this.getCompanyFantasyName}`,
        headerInfoStartX + headerSpacing,
        headerInfoStartY +
          headerFontSize / headerFontDivisionBase +
          (headerFontSize / headerFontDivisionBase) * headerLine +
          headerLineSpacing * headerLine
      );
      // LINE 3
      headerLine = 2;
      doc.text(
        `EXPORTADO POR: ${this.getUserDisplayName}`,
        headerInfoStartX + headerSpacing,
        headerInfoStartY +
          headerFontSize / headerFontDivisionBase +
          (headerFontSize / headerFontDivisionBase) * headerLine +
          headerLineSpacing * headerLine
      );
      // LINE 4
      headerLine = 3;
      doc.text(
        `DATA DE EXPORTAÇÃO: ${formattedExportDate}`,
        headerInfoStartX + headerSpacing,
        headerInfoStartY +
          headerFontSize / headerFontDivisionBase +
          (headerFontSize / headerFontDivisionBase) * headerLine +
          headerLineSpacing * headerLine
      );

      // TENANT LOGO
      let logoHeightSpaceCalc =
        headerInfoStartY +
        headerFontSize / headerFontDivisionBase +
        (headerFontSize / headerFontDivisionBase) * headerLine +
        headerLineSpacing * headerLine -
        startY;
      doc.addImage(
        logoSrc,
        "PNG",
        startX,
        startY + (logoHeightSpaceCalc - logoHeaderHeight) / 2,
        logoHeaderWidth,
        logoHeaderHeight
      );

      let finalY =
        headerInfoStartY +
        headerFontSize / headerFontDivisionBase +
        (headerFontSize / headerFontDivisionBase) * headerLine +
        headerLineSpacing * headerLine;

      return finalY;
    },
    pdfAddAppliedFilters(doc, startY, margin, pageWidth, pageOrientation) {
      const fontSize = 8;
      const spacing = 2;
      const rectPadding = 3;
      const fontDivisionBase = 3;
      let startX = margin + rectPadding;
      let rectX = startX - rectPadding;

      startY += margin + rectPadding;

      doc.setFontSize(12);
      doc.setTextColor(100);
      if (Object.keys(this.filterValues).length > 0) {
        doc.text("FILTROS APLICADOS", startX, startY);
        startY += spacing;
      }

      let rectY =
        startY - doc.getTextDimensions(`FILTROS APLICADOS`).h - rectPadding;

      doc.setFontSize(fontSize);
      doc.setTextColor(100);

      let filterLine = 0;
      let biggerText = 0;
      let finalY = 0;
      Object.keys(this.filterValues).forEach(key => {
        const value = this.filterValues[key];
        if (value !== "" && value !== false) {
          const displayValue =
            typeof value === "boolean" ? (value ? "Sim" : "Não") : value;
          const textDimensions = doc.getTextDimensions(
            `${this.filterTitles[key]}: ${
              key == "startDate" || key == "endDate"
                ? this.formatBrazilianDate(value)
                : displayValue
            }`
          );
          biggerText =
            textDimensions.w > biggerText ? textDimensions.w : biggerText;
          if (key == "startDate" || key == "endDate") {
            doc.text(
              `${this.filterTitles[key]}: ${this.formatBrazilianDate(value)}`,
              startX,
              startY +
                fontSize / fontDivisionBase +
                (fontSize / fontDivisionBase) * filterLine +
                spacing * filterLine
            );
          } else {
            doc.text(
              `${this.filterTitles[key]}: ${displayValue}`,
              startX,
              startY +
                fontSize / fontDivisionBase +
                (fontSize / fontDivisionBase) * filterLine +
                spacing * filterLine
            );
          }
          if (
            startY +
              fontSize / fontDivisionBase +
              (fontSize / fontDivisionBase) * filterLine +
              spacing * filterLine >
            finalY
          ) {
            finalY =
              startY +
              fontSize / fontDivisionBase +
              (fontSize / fontDivisionBase) * filterLine +
              spacing * filterLine;
          }
          if (filterLine == 3) {
            startX = margin + biggerText + margin;
            biggerText = 0;
            filterLine = 0;
          } else {
            filterLine++;
          }
        }
      });

      if (this.sortedColumn) {
        doc.text(
          `Dados agrupados por: ${this.sortedColumn[0].colDef.headerName} (${
            this.sortedColumn[0].sort == "asc" ? "Ascendente" : "Descendente"
          })`,
          startX,
          startY +
            fontSize / fontDivisionBase +
            (fontSize / fontDivisionBase) * filterLine +
            spacing * filterLine
        );
        if (
          startY +
            fontSize / fontDivisionBase +
            (fontSize / fontDivisionBase) * filterLine +
            spacing * filterLine >
          finalY
        ) {
          finalY =
            startY +
            fontSize / fontDivisionBase +
            (fontSize / fontDivisionBase) * filterLine +
            spacing * filterLine;
        }
      }

      doc.rect(
        rectX,
        rectY,
        pageWidth - margin * 2,
        finalY - rectY + rectPadding
      );

      return (
        startY +
        fontSize / fontDivisionBase +
        (fontSize / fontDivisionBase) * filterLine +
        spacing * filterLine +
        margin +
        rectPadding
      );
    },
    async pdfAddFooter(doc, pageWidth, pageHeight, margin) {
      const totalPages = doc.internal.getNumberOfPages();

      const pdfInstagramMarking = "/img/pdf-instagram-marking.png";
      let pdfInstagramMarkingDimensions = await this.getImageDimensions(
        pdfInstagramMarking
      );

      const pdfInstagramMarkingWidth = 30;
      const ratio =
        pdfInstagramMarkingDimensions.height /
        pdfInstagramMarkingDimensions.width;
      let pdfInstagramMarkingHeight = pdfInstagramMarkingWidth * ratio;

      for (let page = 1; page <= totalPages; page++) {
        doc.setPage(page);
        doc.setFontSize(8);
        doc.setTextColor(100);

        let pageTextDimensions = doc.getTextDimensions(
          `Página ${page} de ${totalPages}`
        );

        doc.addImage(
          pdfInstagramMarking,
          "PNG",
          margin,
          pageHeight - margin - pdfInstagramMarkingHeight / 2,
          pdfInstagramMarkingWidth,
          pdfInstagramMarkingHeight
        );

        doc.text(
          `Página ${page} de ${totalPages}`,
          pageWidth - pageTextDimensions.w - 10,
          pageHeight -
            margin -
            pdfInstagramMarkingHeight / 2 +
            pdfInstagramMarkingHeight -
            (pdfInstagramMarkingHeight - pageTextDimensions.h) / 2
        );
      }
    },
    generatePdfFilename() {
      const now = new Date();
      const pad2 = n => n.toString().padStart(2, "0");
      const dia = pad2(now.getDate());
      const mes = pad2(now.getMonth() + 1);
      const ano = now.getFullYear();
      const hora = pad2(now.getHours());
      const min = pad2(now.getMinutes());
      const seg = pad2(now.getSeconds());

      const baseName = this.pdfExportPrefs.pdfConfig.reportNickname;
      const timestamp = `${dia}${mes}${ano}_${hora}${min}${seg}`;
      const fileName = `${baseName}_${timestamp}.pdf`;

      return fileName;
    },
    pdfAddPage(doc, pageOrientation) {
      if (pageOrientation == 1) {
        doc.addPage("a4", "landscape");
      } else {
        doc.addPage("a4", "portrait");
      }
    },
    formatBrazilianDate(dateString) {
      const date = new Date(dateString);

      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Meses começam de 0
      const year = date.getUTCFullYear();

      return `${day}/${month}/${year}`;
    },
    getImageDimensions(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = src;
      });
    },
    getSortedTableData() {
      const sorted = [];
      this.$refs.mainTable.gridApi.forEachNodeAfterFilterAndSort(node => {
        sorted.push(node.data);
      });
      return sorted;
    },
    resolveProps(item) {
      const type = item.type;
      const propObj = item.props;
      switch (type) {
        case "header":
          return {
            reportNickname: this.pdfExportPrefs.pdfConfig.reportNickname,
            logoSrc: this.companyLogoSrc,
            companyFantasyName: this.getCompanyFantasyName,
            userDisplayName: this.getUserDisplayName
          };
        case "card":
          return {
            id: "pdf-component-" + item.i,
            title: this.cardTitles[propObj.title],
            value: this.supplyDashboardData.cards[propObj.value].value,
            icon: this.cardIcons[propObj.icon],
            forceLight: true
          };
          break;
        case "chart":
          return {
            id: "pdf-component-" + item.i,
            title: this.chartTitles[propObj.title],
            model: this.supplyDashboardData.charts[propObj.model].model
          };
          break;
        case "table":
          let tablePrefsWithoutLinks = this.tableColumnPrefs.map(pref => {
            return pref.colId == "link" ? { ...pref, hide: true } : pref;
          });
          return {
            id: "pdf-component-" + item.i,
            rowData: this.supplyDashboardData[propObj.items],
            columnDefs: this[propObj.columns],
            defaultColumnPrefs: tablePrefsWithoutLinks,
            ref: [propObj.ref],
            forceLightTheme: true
          };
          break;
      }
    },
    resolveListeners(item) {
      if (item.type === "table") {
        return {
          "sort-changed": this.handleSortedColumnChanged
        };
      }
      return {};
    },
    toggleAllColumns(checked) {
      this.tableColumnPrefs.forEach(pref => {
        pref.hide = !checked;
      });
      this.applyPrefsToTables();
    },
    getHeaderName(colId) {
      const col = this.tableColumnDefs.find(def => def.field === colId);
      return col ? col.headerName : colId;
    },
    normalizeTableColumnPrefs(savedPrefs) {
      const safeSavedPrefs = Array.isArray(savedPrefs) ? savedPrefs : [];
      const validColIds = new Set(
        this.tableColumnDefs.map(colDef => colDef.field)
      );
      const currentPrefsByColId = new Map(
        this.tableColumnPrefs.map(pref => [pref.colId, pref])
      );

      const normalizedSavedPrefs = safeSavedPrefs
        .filter(pref => pref?.colId && validColIds.has(pref.colId))
        .map(pref => ({
          ...currentPrefsByColId.get(pref.colId),
          ...pref
        }));

      const missingPrefs = this.tableColumnDefs
        .filter(
          colDef =>
            !normalizedSavedPrefs.some(pref => pref.colId === colDef.field)
        )
        .map(colDef => {
          const currentPref = currentPrefsByColId.get(colDef.field);
          return (
            currentPref || {
              colId: colDef.field,
              width: 120,
              hide: false
            }
          );
        });

      return [...normalizedSavedPrefs, ...missingPrefs];
    },
    onMainTableStateChanged(newState) {
      this.tableColumnPrefs = newState;
      this.$refs.gridTable.applyColumnState(
        this.tableColumnPrefs.map(pref => {
          return pref.colId == "link" ? { ...pref, hide: true } : pref;
        })
      );
    },
    handleSortedColumnChanged(sortColumn) {
      this.sortedColumn = sortColumn[0] ? sortColumn : null;

      const sortModel = sortColumn.map(col => ({
        colId: col.colId,
        sort: col.sort
      }));

      const mainTableState = this.$refs.mainTable.gridColumnApi.getColumnState();
      const newStateMain = mainTableState.map(colState => {
        const m = sortModel.find(m => m.colId === colState.colId);
        return {
          ...colState,
          sort: m ? m.sort : null
        };
      });
      this.$refs.mainTable.gridColumnApi.applyColumnState({ state: newStateMain, applyOrder: false });

      const gridTableState = this.$refs.gridTable.gridColumnApi.getColumnState();
      const newStateGrid = gridTableState.map(colState => {
        const m = sortModel.find(m => m.colId === colState.colId);
        return {
          ...colState,
          sort: m ? m.sort : null
        };
      });
      this.$refs.gridTable.gridColumnApi.applyColumnState({ state: newStateGrid, applyOrder: false });
    },
    toggleColumnVisibility(index, event) {
      this.tableColumnPrefs[index].hide = !event;
      this.applyPrefsToTables();
    },
    applyPrefsToTables() {
      if (this.$refs.mainTable) {
        this.$refs.mainTable.applyColumnState(this.tableColumnPrefs);
      }
      if (this.$refs.gridTable) {
        this.$refs.gridTable.applyColumnState(
          this.tableColumnPrefs.map(pref => {
            return pref.colId == "link" ? { ...pref, hide: true } : pref;
          })
        );
      }
    },
    parsePreferenceData(data) {
      if (typeof data !== "string") {
        return data;
      }

      try {
        return JSON.parse(data);
      } catch (e) {
        console.error("Erro ao interpretar prefs:", e);
        return data;
      }
    },
    async loadPreferences(prefType) {
      try {
        const resp = await this.$apiScheduler.get("/userPreference", {
          params: {
            contextKey: "SupplyDashboardHorimetro",
            preferenceType: prefType
          }
        });
        const data = this.parsePreferenceData(resp.data);
        if (prefType === "tablePrefs") {
          this.tableColumnPrefs = this.normalizeTableColumnPrefs(data);
        } else if (prefType === "pdfExportPrefs") {
          this.pdfExportPrefs = data;
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.errorMessage = null;
        } else {
          console.error("Erro ao carregar prefs:", e);
        }
      }
    },
    async savePreferences(prefType, payload) {
      this.saveTablePrefsLoading = prefType === "tablePrefs";
      this.savePdfExportPrefsLoading = prefType === "pdfExportPrefs";
      await this.$apiScheduler.post("/userPreference", {
        ContextKey: "SupplyDashboardHorimetro",
        PreferenceType: prefType,
        Data: JSON.stringify(payload)
      });
      this.alert.success =
        prefType === "tablePrefs"
          ? "Preferências da tabela salvas com sucesso!"
          : "Preferências da exportação PDF salvas com sucesso!";
      this.$refs.successFadeAlert.show();
      this.saveTablePrefsLoading = false;
      this.savePdfExportPrefsLoading = false;
    },
    goToExportLayout() {
      this.menu.value = "4";
      const opt = this.menu.options.find(o => o.value === "4");
      if (opt) {
        this.$refs.menuLogic.setValue(opt);
      }
    },
    async exportCsv() {
      this.exportCsvLoading = true;
      try {
        const resp = await this.$apiVehicle.post(
          "/fuelSupply/dashboard/horimetro/exportcsv",
          this.filterValues,
          { responseType: "arraybuffer" }
        );

        const fileName =
          resp.headers["filename"] || `dashboard_${Date.now()}.csv`;
        const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Erro ao exportar CSV:", error);
        this.errorMessage = "Não foi possível gerar o CSV.";
        this.$refs.fadeAlertDanger.show();
      } finally {
        this.exportCsvLoading = false;
      }
    },
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
};
</script>

<style scoped>
.supply-dashboard {
  width: 100%;
  padding: 5px;
  overflow: off;
}

.filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 5px;
}

.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(auto-fill, 117px);
  gap: 10px;
}

.gauge {
  grid-row: 1 / span 2;
}

.full-width-card {
  grid-column: span 3;
}

.charts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.top-menu {
  display: flex;
  gap: 10px;
}

.auto-refresh {
  margin-left: auto;
  align-items: center;
}

.charts2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 10px;
}

@media (max-width: 1400px) {
  .full-width-card {
    grid-column: span 3;
  }
  .charts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    margin-top: 10px;
  }
  .cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(auto-fill, 117px);
    gap: 10px;
  }
  .top-menu {
    display: flex;
  }
  .auto-refresh {
    margin-left: auto;
    align-items: center;
  }
}
@media (max-width: 768px) {
  .charts {
    grid-template-columns: 1fr;
  }
  .charts2 {
    grid-template-columns: 1fr;
  }
  .cards {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(auto-fill, 117px);
  }
  .top-menu {
    flex-direction: column;
  }
  .auto-refresh {
    display: none;
  }
  .full-width-card {
    grid-column: span 1;
  }
  .filters {
    flex-direction: column;
  }
  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .supply-dashboard {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
  }

  .charts,
  .charts2,
  .cards {
    flex: 1;
    box-sizing: border-box;
  }
  .cards > *:last-child,
  .charts > *:last-child,
  .charts2 > *:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
</style>
